// extracted by mini-css-extract-plugin
export var arrow = "_ib-1";
export var content = "_ib-0";
export var highlighted = "_ib-2";